import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';

/**
 * Component for employment types that only have "other income" field.
 * Used for: Student, Arbeitsloser (Unemployed), Hausfrau (Housewife)
 */
export const OtherIncomeOnly: React.FC = () => {
    const { t } = useTranslation();
    const { control, watch } = useFormContext<ApplicantCreation>();

    const beschaeftigungsart = watch('beschaeftigung.beschaeftigungsart');

    const getTypeKey = () => {
        switch (beschaeftigungsart) {
            case EMPLOYMENT_TYPES.STUDENT:
                return 'student';
            case EMPLOYMENT_TYPES.ARBEITSLOSER:
                return 'arbeitsloser';
            case EMPLOYMENT_TYPES.HAUSFRAU:
                return 'hausfrau';
            default:
                return 'student';
        }
    };

    const basePath = `beschaeftigung.${getTypeKey()}` as const;

    return (
        <div className="mt-4 space-y-2">
            <p className="text-sm text-midnight text-center">
                {t('CREDIT_WORTHINESS.SECTIONS.EMPLOYMENT.SUBSECTIONS.INCOME_HEALTH_INSURANCE')}
            </p>

            <FormCurrencyInput
                id={`${basePath}.sonstigesEinkommenMonatlich` as Path<ApplicantCreation>}
                label={t('CREDIT_WORTHINESS.SECTIONS.INCOME.OTHER_INCOME')}
                control={control}
                min={0}
            />
        </div>
    );
};
